/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_OO as OO,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_kO as kO,
  rec_yS as yS,
} from "../../runtime/index.jsx";
export function Componente_DO_68_79(e) {
  let t = (0, ReactCompiler.c)(12),
    { dias: n, onCerrar: r, onDia: i } = e,
    a;
  if (t[0] !== n || t[1] !== r || t[2] !== i) {
    let e = n.filter(kO),
      o = n[0].fecha,
      s = n[n.length - 1].fecha,
      c;
    t[4] === o ? (c = t[5]) : ((c = yS(o)), (t[4] = o), (t[5] = c));
    let l;
    t[6] === o ? (l = t[7]) : ((l = o.getDate()), (t[6] = o), (t[7] = l));
    let u;
    t[8] === s ? (u = t[9]) : ((u = s.getDate()), (t[8] = s), (t[9] = u));
    let d;
    (t[10] === s
      ? (d = t[11])
      : ((d = s.toLocaleDateString(`es-PE`, {
          month: `long`,
        })),
        (t[10] = s),
        (t[11] = d)),
      (a = (
        <Modal
          titulo={`Semana ${c} · ${l} al ${u} de ${d}`}
          onClose={r}
          children={
            e.length === 0 ? (
              <p
                className={`rounded-xl border border-dashed border-(--border) px-3 py-6 text-center text-sm text-(--text)`}
                children={`Esta semana está libre.`}
              />
            ) : (
              <ul
                className={`animar-cascada flex flex-col gap-1.5`}
                children={e.map((e) => (
                  <li
                    key={e.clave}
                    children={
                      <button
                        type={`button`}
                        onClick={() => i(e)}
                        className={`flex w-full items-baseline gap-2 rounded-xl border border-(--border) px-3 py-2 text-left text-sm transition hover:bg-(--accent-bg)`}
                        children={[
                          <span
                            className={`w-20 shrink-0 text-xs capitalize text-(--text)`}
                            children={e.fecha
                              .toLocaleDateString(`es-PE`, {
                                weekday: `short`,
                                day: `numeric`,
                              })
                              .replace(`.`, ``)}
                          />,
                          <span
                            className={`min-w-0 flex-1 truncate text-(--text-h)`}
                            children={e.eventos.map(OO).join(` · `)}
                          />,
                          <span
                            className={`shrink-0 text-xs text-(--text)`}
                            children={e.eventos.length}
                          />,
                        ]}
                      />
                    }
                  />
                ))}
              />
            )
          }
        />
      )),
      (t[0] = n),
      (t[1] = r),
      (t[2] = i),
      (t[3] = a));
  } else a = t[3];
  return a;
}
